<div class="raise-request">
  <div class="filter-container">
    <emerald-button
    [type]="'Secondary'"
    [label]="'Filter'"
    [size]="'Medium'"
    [icon]="'filter_list'"
    (click)="opened = true"
  ></emerald-button>
  <emerald-modal
    [opened]="opened"
    [headerText]="'Filter'"
    [hasCloseIcon]="true"
    [closeOnOutsideClick]="true"
    (onDismiss)="opened = false"
  >
    <ng-container *ngIf="openForm">
      <form [formGroup]="filterForm">
        <ng-container
          *ngIf="
            fieldsVisibility === personaType.HireMgrJobDet ||
            fieldsVisibility === personaType.VendorRepJobDet ||
            fieldsVisibility === personaType.OpsTeamJobDet
          "
        >
          <emerald-dropdown
            [options]="nameOptions"
            formControlName="selectedName"
            [outlined]="true"
            [id]="'single_select'"
            [label]="'Name'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          ></emerald-dropdown
          ><br />
          <emerald-dropdown
            [options]="experience"
            [outlined]="true"
            formControlName="selectedExperience"
            [id]="'single_select'"
            [label]="'Experience'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          ></emerald-dropdown
          ><br />
          <emerald-dropdown
            [options]="locationOptions"
            [outlined]="true"
            formControlName="selectedLocation"
            [id]="'single_select'"
            [label]="'Location'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          ></emerald-dropdown
          ><br />
          <ng-container *ngIf="fieldsVisibility === personaType.HireMgrJobDet"
            ><emerald-datepicker
              [isOutlined]="true"
              [label]="'Available By'"
              formControlName="selectedAvailableBy"
            ></emerald-datepicker>
            <br
          /></ng-container>
          <ng-container *ngIf="fieldsVisibility === personaType.HireMgrJobDet"
            ><emerald-datepicker
              [isOutlined]="true"
              [label]="'Received On'"
              formControlName="selectedReceivedOn"
            ></emerald-datepicker
            ><br
          /></ng-container>

          <emerald-dropdown
            [options]="status"
            formControlName="selectedStatus"
            [id]="'single_select'"
            [label]="'Request Status'"
            [outlined]="true"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          ></emerald-dropdown
          ><br />
          <emerald-dropdown
            [options]="vendorNameOptions"
            formControlName="selectedVendorName"
            [id]="'single_select'"
            [label]="'Vendor Name'"
            [outlined]="true"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          ></emerald-dropdown
          ><br />
        </ng-container>
      </form>
    </ng-container>
    <ng-container actions>
      <ng-container>
        <span class="mdc-dialog__button">
          <emerald-button
            [type]="'Secondary'"
            (onClick)="opened = true; reset()"
            >Reset</emerald-button
          >
        </span>
        <span class="mdc-dialog__button">
          <emerald-button
            color="primary"
            (click)="opened = false; apply()"
            label="Save"
          >
            Apply
          </emerald-button>
        </span>
      </ng-container>
    </ng-container>
  </emerald-modal>
</div>
</div>
